<template>
  <roe-error-message :field="design.match_dollar_limit_amount">
    <input
      type="number"
      v-model="design.$model.match_dollar_limit_amount"
      name="match_dollar_limit_amount"
      required
    />
    <label class="input-label-inside">$</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchDollarAmountInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
